import { Box, Button, CssBaseline, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import Icon from "@mdi/react";
import { mdiAccountOff } from "@mdi/js";
import { borderRadiusStandard } from "../../../theme";
import { buildHomePageUrl } from "../../../utils/BuildURLs";

export const UserDisabledPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParameters] = useSearchParams();
  const email = searchParameters.get("emailAddress")!;

  return (
    <Grid container component="main" sx={{ height: "100vh" }}>
      <CssBaseline />
      <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
        <Grid container>
          <Grid xs={2} />
          <Grid xs={8} sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <Box sx={{ minWidth: "200px", minHeight: "200px", p: 4, borderRadius: borderRadiusStandard, mt: 1, background: "white", textAlign: "center" }}>
              <Icon path={mdiAccountOff} size={5} style={{ marginTop: "24px" }} />
              <Typography variant="h4" fontWeight={700} my={2}>
                {email ? t("user_disabled_page.user_disabled_message", { email: email }) : t("user_disabled_page.user_is_not_enabled_generic_message")}
              </Typography>
              <Typography variant="h5" fontWeight={700} my={2}>
                {t("user_disabled_page.please_contact_school_admin")}
              </Typography>
              <Button
                variant="contained"
                onClick={() => {
                  const homePageUrl = buildHomePageUrl();
                  navigate(homePageUrl);
                }}
                sx={{ borderRadius: borderRadiusStandard }}
              >
                {t("common.go_to_homepage")}
              </Button>
            </Box>
          </Grid>
          <Grid xs={2} />
        </Grid>
      </Grid>
    </Grid>
  );
};
